/**
* StartGameCommand.js
* 
* Created on Oct 17, 2013, 11:52:42 AM
*
* @author Javier Quevedo-Fernandez for Ranj
**/
import AbstractCommand from '../../core/application/AbstractCommand';
import ScenarioCommandEvent from "../scenario/controller/ScenarioCommandEvent";

export default class StartGameCommand extends AbstractCommand {

    constructor(dispatcher) {
        super(dispatcher);

        this.execute = function (evt) {
            this.dispatch(ScenarioCommandEvent.INITIALIZE_SCENARIOS);
            //Play default scenario
            //(Or use 2nd argument to play specific scenario: { scenario: "{firstScenarioId}" } )
            this.dispatch(ScenarioCommandEvent.PLAY_SCENARIO);
        };
    };

}